// @flow

import { p2pLog } from '../logger'

import { p2pStatsCollector } from './collector'

export const attachP2PDebug = (engine: any, player: any) => {
  if (!engine) {
    return
  }

  try {
    p2pStatsCollector.reset()
    p2pStatsCollector.setBound(true)
    p2pStatsCollector.setPlayer(player)

    engine.addEventListener('onChunkDownloaded', (bytesLength, downloadSource) =>
      p2pStatsCollector.addDownloaded(bytesLength, downloadSource),
    )
    engine.addEventListener('onChunkUploaded', bytesLength => p2pStatsCollector.addUploaded(bytesLength))

    engine.addEventListener('onPeerConnect', params => {
      if (params.streamType !== 'main') {
        return
      }

      p2pStatsCollector.addPeer({
        peerId: params.peerId,
        infoHash: params.infoHash,
      })
    })
    engine.addEventListener('onPeerClose', params => {
      if (params.streamType !== 'main') {
        return
      }

      p2pStatsCollector.removePeer({
        peerId: params.peerId,
        infoHash: params.infoHash,
      })
    })
  } catch (err) {
    p2pLog('[P2P][Overlay] attach failed:', err)
  }
}

export const detachP2PDebug = (): void => {
  p2pStatsCollector.setBound(false)
  p2pStatsCollector.setPlayer(null)
  p2pStatsCollector.reset()
}
